import router from '../router';

/*
 * 跳轉回首頁
 * 攜帶當前的頁面路由，登入完成後跳轉回原本頁面
 */

export const gotoUserLogin = store => {
	router.replace({
		name: 'signin',
		params: {},
	});
};

/*
export const gotoLogin = () => {
  router.replace({
    name: 'login',
    query: {
      redirect: router.currentRoute.fullPath,
    },
  });
};
*/

/*
 * 跳轉到 403 error page
 * 攜帶當前的頁面路由，點擊連結後跳轉回原本頁面
 */
export const goto403Page = () => {
	router.replace({
		name: '403',
	});
};
